import { FormValidations, SetValidationErrorFunction, SetValidationRuleFunction, ValidationActionType } from "features/shared/forms/hooks/useForm";
import PatternValidatonRule from "features/validation/rules/PatternValidatonRule";
import SipoValidator from "features/validation/validators/SipoValidator";
import { inversifyContainer } from "infrastructure/ioc/ioc.container";
import { IocTypes } from "infrastructure/ioc/ioc.types";

export const sipoAccountValidations = (): FormValidations => {
  return {
    sipoNumber: {
      required: true,
      regex: /^\d{10}$/,
      message: "sipoAccountValidations.sipoNumber",
      type: "Pattern",
    } as PatternValidatonRule
  };
}

export const validateSipo = (
  sipo: string,
  validateFormField: (key: string, value: any) => boolean,
  setValidationError: SetValidationErrorFunction
): boolean => {
  let SipoValidator = inversifyContainer.get<SipoValidator>(IocTypes.SipoValidator);
  let isValid = false;

  if (validateFormField("sipoNumber", sipo)) {
    if (!SipoValidator.validateSipo(sipo, false)) {
      setValidationError("sipoNumber", "sipoAccountValidations.invalidSipoNumber");
    } else {
      setValidationError("sipoNumber", null, "remove");
      isValid = true;
    }  
  }

  return isValid;
};

export const setSipoAccountValidations = (
  setValidationRule: SetValidationRuleFunction,
  action: ValidationActionType = "add"
) => {
  const validations = sipoAccountValidations();

  setValidationRule("sipoNumber", validations["sipoNumber"], action);
};